import styled, { css } from "styled-components";

const rowContainer = css`
  display: flex !important;
  flex-direction: row !important;
`;

const columnContainer = css`
  display: flex !important;
  flex-direction: column !important;
`;

export const label = css`
  background-color: blue;
  height: 10px;
  width: 10px;
`;

export const DescriptionContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: flex-bottom;
`;

export const TopBar = styled.div`
  ${rowContainer}
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  background-color: #f8f8f8;
  ${(props) => (props.isMobile ? "" : "height: 70px;")}
`;

export const Body = styled.div`
  display: flex;
  padding: 20px 30px;
`;

export const ButtonGroup = styled.div`
  ${rowContainer}
  align-items: center;
  justify-content: space-between;
`;

export const Button = styled.div`
  background-color: #2c3d4f;
  color: #fff;
  padding: 5px 10px;
  border-radius: px;
  margin: 0px 10px;
  font-size: 20px;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 10%;
  left: 90%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  background-color: transparent;
  color: #f8f8f8;
  font-size: 12px;
  border: none;
  cursor: pointer;
  border-radius: 50px;
  outline: none;
`;

export const ImageContainer = styled.div`
  position: relative;
`;

export const SwitchView = styled.div`
  ${rowContainer}
  align-items: right;
`;

export const SwitchLabel = styled.span`
  ${(props) =>
    props.useChinese
      ? `font-family: 'Microsoft JhengHei', sans-serif;        `
      : `font-family: 'Rambla', 'Arial', sans-serif;`}
  font-size: 16px;
  margin-right: 20px;
  display: inline-flex;
  align-items: center;
  color: #2c3c50;
`;

export const TopBarContainer = styled.div`
  ${(props) => (props.isMobile ? columnContainer : rowContainer)}
`;

export const ButtonGroupContainer = styled.div`
  ${(props) =>
    props.isMobile
      ? "flex-direction: column; display: flex;"
      : "padding-left: 20px; flex: 1;"}
`;

export const AssetListContainer = styled.div`
  ${columnContainer}
  flex: 3;
`;

/**    @media (min-width: 2000px) {
     margin-right: 100px;

  }
   @media (min-width: 2500px) {
     margin-right: 150px;
  }
   @media (min-width: 3000px) {
     margin-right: 200px;
  } */
export const AssetItem = styled.div`
  border-radius: 5px;
  margin-bottom: 13px;
  cursor: pointer;
  box-shadow: 0 2px 5px 0 rgba(184, 184, 184, 0.5);
  /*  display: none;*/

  ${(props) => (props.isRow ? "display: flex; flex-direction: row;" : "")}
`;

export const AssetItemText = css`
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.5px;
  color: #2c3c50;
`;

export const AssetItemTitle = styled.div`
  ${(props) =>
    props.isChinese
      ? `font-family: 'Microsoft JhengHei', sans-serif;        `
      : `font-family: 'Rambla', 'Arial', sans-serif;`}
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.6px;
  color: #2c3c50;
`;

export const AssetTechnicalName = styled.div`
  ${(props) =>
    props.isChinese
      ? `font-family: 'Microsoft JhengHei', sans-serif;        `
      : `font-family: 'Rambla', 'Arial', sans-serif;`}
  font-size: 12px;
  font-weight: normal;
  font-style: italic;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.5px;
  color: #2c3c50;
`;

export const AssetItemName = styled.div`
  ${(props) =>
    props.isChinese
      ? `font-family: 'Microsoft JhengHei', sans-serif;        `
      : `font-family: 'Rambla', 'Arial', sans-serif;`}
  ${AssetItemText}
    ${(props) =>
    props.location
      ? css`
          font-size: 12px;
        `
      : `font-size: 14px`}
    ${(props) =>
    props.truncate
      ? `
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2; /* number of lines to show */
        line-height: X;        /* fallback */
        max-height: X*N;
    `
      : ``}
`;

export const AssetItemPrice = styled.div`
  ${(props) =>
    props.isChinese
      ? `font-family: 'Microsoft JhengHei', sans-serif;        `
      : `font-family: 'Rambla', 'Arial', sans-serif;`}
  font-size: 18px;
  ${AssetItemText}
`;

export const Placeholder = styled.span`
  background-color: #f8f8f8;
  width: "220px";
  height: "147px";
`;

export const AssetBody = styled.div`
  display: flex;
  padding: 30px;
`;

export const AssetTitle = styled.span`
  font-size: 20px;
  font-weight: 600;
  color: #474747;
`;

export const MapContainer = styled.div`
  flex: 2;
`;

export const MapMarkerText = styled.div`
  ${(props) =>
    props.isChinese
      ? `font-family: 'Microsoft JhengHei', sans-serif;        `
      : `font-family: 'Rambla', 'Arial', sans-serif;`}
  font-size: 12px;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  ${(props) =>
    props.isTitle
      ? css`
          color: #bababa;
        `
      : `color: #2c3c50;`}
  ${(props) =>
    props.bold
      ? css`
          font-weight: bold;
        `
      : `font-weight: normal;`}
`;

export const BubbleContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  width: 250px;
  height: 250px;
`;

export const BubbleTriangle = styled.div`
  width: 0;
  height: 0;
  border-color: #ffffff;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 11px solid #ffffff;
`;

export const TriangleContainer = styled.div`
  ${rowContainer}
  align-items: center;
  justify-content: center;
`;
